import { useState } from 'react'
import { LoadingAnimation, Flex } from '@/components'
import { Plan } from '@/types/plan'
import clsx from 'clsx'
import Select from '@/app/components/Select'

export interface Props {
  planOptions: Plan[]
  isLoading: boolean
  label?: string
  selectedPlanId?: number
  onChange?: (planId: number) => void
  className?: string
  required?: boolean
}

export default function UtilityPlanDropdown({
  planOptions,
  isLoading,
  label = 'Select a plan',
  selectedPlanId,
  onChange,
  className,
  required = false,
}: Props) {
  const [internalId, setInternalId] = useState<number | null>(
    selectedPlanId ?? null,
  )

  // keep controlled + uncontrolled in sync
  const currentId = selectedPlanId ?? internalId
  const handleSelect = (id: number) => {
    setInternalId(id)
    onChange?.(id)
  }

  const title = (p: Plan) => (p.is_default ? `[Most Common] ${p.name}` : p.name)

  if (isLoading) {
    return (
      <Flex container justifyContent="center">
        <LoadingAnimation type="flashing" />
      </Flex>
    )
  }

  const plans = planOptions.map((plan) => ({
    id: plan.id,
    name: title(plan),
  }))

  return (
    <div className={clsx('h-fit', className)}>
      <Select
        options={plans}
        onChange={handleSelect}
        required={required}
        label={label}
        selectedOptionId={currentId ?? undefined}
      />
    </div>
  )
}
